(function() {
  const alignedFieldKeys = [
    'above-eyebrow',
    'eyebrow',
    'heading',
    'text',
    'subtext',
    'price',
    'html',
    'liquid',
    'cta',
    'below-cta'
  ];

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function getVisibleCards(container) {
    return Array.from(container.querySelectorAll('.gf-align-card')).filter(function(card) {
      return card.getClientRects().length > 0;
    });
  }

  function groupCardsByTop(cards) {
    const rows = [];
    const tolerance = 4;

    cards.forEach(function(card) {
      const top = Math.round(card.getBoundingClientRect().top);
      let row = rows.find(function(item) {
        return Math.abs(item.top - top) <= tolerance;
      });

      if (!row) {
        row = { top: top, cards: [] };
        rows.push(row);
      }

      row.cards.push(card);
    });

    return rows;
  }

  function normalizeFieldHeights(sectionRoot) {
    sectionRoot.querySelectorAll('.gf-field').forEach(function(field) {
      field.style.minHeight = '';
    });

    sectionRoot.querySelectorAll('[data-bsg-flexible-dropdown-item][open]').forEach(function(item) {
      item.querySelectorAll('.flexible-columns-grid, .flexible-columns-slider').forEach(function(container) {
        const rows = groupCardsByTop(getVisibleCards(container));
        rows.forEach(function(row) {
          alignedFieldKeys.forEach(function(fieldKey) {
            const fields = row.cards.map(function(card) {
              return card.querySelector('.gf-field--' + fieldKey);
            }).filter(Boolean);

            if (!fields.length) return;

            const maxHeight = fields.reduce(function(max, field) {
              return Math.max(max, field.offsetHeight);
            }, 0);

            if (maxHeight > 0) {
              fields.forEach(function(field) {
                field.style.minHeight = maxHeight + 'px';
              });
            }
          });
        });
      });
    });
  }

  function queueNormalize(sectionRoot) {
    window.clearTimeout(sectionRoot.bsgFlexibleDropdownNormalizeTimer);
    sectionRoot.bsgFlexibleDropdownNormalizeTimer = window.setTimeout(function() {
      normalizeFieldHeights(sectionRoot);
    }, 90);
  }

  function initPanelSlider(sectionRoot, item) {
    if (!item || item.dataset.bsgFlexibleDropdownSliderInitialized === 'true') return;

    const slider = item.querySelector('.flexible-columns-slider');
    const wrapper = item.querySelector('.mobile-slider-wrapper');
    const prevButton = item.querySelector('button[name="previous"]');
    const nextButton = item.querySelector('button[name="next"]');
    const scrollHint = item.querySelector('.gf-scroll-hint');
    const slides = slider ? Array.from(slider.querySelectorAll('.slider-item')) : [];
    if (!slider || !slides.length) return;

    item.dataset.bsgFlexibleDropdownSliderInitialized = 'true';
    let currentPage = 1;
    let slideDistance = 0;
    let totalPages = 1;
    let scrollStarted = false;

    function initPages() {
      const firstSlide = slides[0];
      if (!firstSlide) return false;

      slideDistance = slides.length > 1
        ? slides[1].offsetLeft - firstSlide.offsetLeft
        : firstSlide.offsetWidth;

      if (!slideDistance) return false;

      const slidesPerPage = Math.max(1, Math.floor((slider.clientWidth - firstSlide.offsetLeft) / slideDistance));
      totalPages = Math.max(1, slides.length - slidesPerPage + 1);
      return true;
    }

    function updateButtons() {
      if (!prevButton || !nextButton) return;
      currentPage = clamp(currentPage, 1, totalPages);
      prevButton.toggleAttribute('disabled', currentPage <= 1);
      nextButton.toggleAttribute('disabled', currentPage >= totalPages);
    }

    function updateHint() {
      if (!scrollHint || !wrapper) return;

      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const canScroll = slider.scrollWidth - slider.clientWidth > 4;
      if (slider.scrollLeft > 4) scrollStarted = true;

      const shouldHide = !isMobile || !canScroll || scrollStarted || !item.open;
      item.classList.toggle('gf-scroll-hint-hidden', shouldHide);
      scrollHint.disabled = shouldHide;
      scrollHint.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
      if (shouldHide) {
        scrollHint.setAttribute('tabindex', '-1');
      } else {
        scrollHint.removeAttribute('tabindex');
      }

      const rect = wrapper.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const progress = clamp((viewportHeight - rect.top) / (viewportHeight + rect.height), 0, 1);
      const hintHeight = scrollHint.offsetHeight || 42;
      const endOffset = Math.max(12, wrapper.clientHeight - hintHeight - 12);
      scrollHint.style.setProperty('--gf-scroll-hint-offset', (12 + (endOffset - 12) * progress).toFixed(2) + 'px');
    }

    function updateIndexFromScroll() {
      if (!initPages()) return;
      currentPage = clamp(Math.round(slider.scrollLeft / slideDistance) + 1, 1, totalPages);
      updateButtons();
      updateHint();
    }

    function scrollByPage(direction) {
      if (!initPages()) return;
      currentPage = clamp(currentPage + direction, 1, totalPages);
      slider.scrollTo({ left: (currentPage - 1) * slideDistance, behavior: 'smooth' });
      updateButtons();
    }

    if (prevButton) {
      prevButton.addEventListener('click', function(event) {
        event.preventDefault();
        scrollByPage(-1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function(event) {
        event.preventDefault();
        scrollByPage(1);
      });
    }

    if (scrollHint) {
      scrollHint.addEventListener('click', function(event) {
        event.preventDefault();
        if (scrollHint.disabled || !initPages()) return;
        const maxLeft = Math.max(0, slider.scrollWidth - slider.clientWidth);
        slider.scrollTo({ left: Math.min(maxLeft, slider.scrollLeft + slideDistance), behavior: 'smooth' });
        scrollStarted = true;
        updateHint();
      });
    }

    slider.addEventListener('scroll', function() {
      window.clearTimeout(item.bsgFlexibleDropdownScrollTimer);
      item.bsgFlexibleDropdownScrollTimer = window.setTimeout(updateIndexFromScroll, 70);
    }, { passive: true });

    window.addEventListener('resize', updateIndexFromScroll);
    window.addEventListener('scroll', updateHint, { passive: true });
    updateIndexFromScroll();
  }

  function initFlexibleDropdownSection(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.bsgFlexibleDropdownInitialized === 'true') return;
    sectionRoot.dataset.bsgFlexibleDropdownInitialized = 'true';

    const items = Array.from(sectionRoot.querySelectorAll('[data-bsg-flexible-dropdown-item]'));
    if (!items.length) return;

    items.forEach(function(item) {
      item.addEventListener('toggle', function() {
        if (item.open) {
          initPanelSlider(sectionRoot, item);
        }
        queueNormalize(sectionRoot);
      });

      if (item.open) {
        initPanelSlider(sectionRoot, item);
      }
    });

    sectionRoot.querySelectorAll('img').forEach(function(image) {
      image.addEventListener('load', function() {
        queueNormalize(sectionRoot);
      }, { passive: true });
    });

    sectionRoot.querySelectorAll('video').forEach(function(video) {
      video.addEventListener('loadedmetadata', function() {
        queueNormalize(sectionRoot);
      }, { passive: true });
    });

    const lazyVideos = sectionRoot.querySelectorAll('video.lazy-autoplay-video');
    if (lazyVideos.length && 'IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          const video = entry.target;
          if (entry.isIntersecting) {
            try { video.play(); } catch (e) {}
          } else {
            try { video.pause(); } catch (e) {}
          }
        });
      }, { root: null, rootMargin: '200px 0px', threshold: 0.25 });

      lazyVideos.forEach(function(video) {
        videoObserver.observe(video);
      });
    }

    window.addEventListener('resize', function() {
      queueNormalize(sectionRoot);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function() {
        queueNormalize(sectionRoot);
      }).catch(function() {});
    }

    queueNormalize(sectionRoot);
  }

  function initAllFlexibleDropdownSections(root) {
    const scope = root || document;
    if (scope.matches && scope.matches('.shopify-section') && scope.querySelector('[data-bsg-flexible-dropdown]')) {
      initFlexibleDropdownSection(scope);
    }

    scope.querySelectorAll('.shopify-section').forEach(function(sectionRoot) {
      if (sectionRoot.querySelector('[data-bsg-flexible-dropdown]')) {
        initFlexibleDropdownSection(sectionRoot);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAllFlexibleDropdownSections(document);
    });
  } else {
    initAllFlexibleDropdownSections(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAllFlexibleDropdownSections(event.target);
  });
})();
